function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M15,7h-2.59003l5.02002,-5l-1.42999,-1.42999l-5,5.02002v-2.59003h-2v6h6zM12.20001,16.21997l1.19,-1.21997c0.84998,0.27002 1.71997,0.41998 2.60999,0.47998v1.52002c-1.32001,-0.12 -2.59003,-0.38 -3.79999,-0.78003zM3.53003,3c0.06995,0.89001 0.21997,1.76001 0.46997,2.59003l-1.21002,1.19995c-0.40997,-1.19995 -0.66998,-2.46997 -0.78998,-3.78998zM17,13.51001c-1.23999,0 -2.45001,-0.20001 -3.57001,-0.57001c-0.09998,-0.03998 -0.21002,-0.04999 -0.31,-0.04999c-0.26001,0 -0.51001,0.10999 -0.71002,0.28998l-2.19995,2.20001c-2.83002,-1.45001 -5.15002,-3.76001 -6.59003,-6.59003l2.20001,-2.19995c0.27997,-0.28003 0.35999,-0.67004 0.25,-1.02002c-0.37,-1.12 -0.57001,-2.32001 -0.57001,-3.57001c0,-0.54999 -0.5,-1 -1,-1h-3.5c-0.54999,0 -1,0.45001 -1,1c0,9.39001 7.60999,17 17,17c0.54999,0 1,-0.45001 1,-1v-3.48999c0,-0.51001 -0.45001,-1 -1,-1z",
  fill: "#b1c3cc",
  fillOpacity: 1
})));

var SvgCallIn = function SvgCallIn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGDoc",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCallIn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/call_in.06fda14d.svg";
export { ForwardRef as ReactComponent };